module.exports = __webpack_public_path__ + "media/images/application/template/logo-bd87b5ba2856cce1bf134b043fb81340.svg";